import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'landing.seen.on.title',
    defaultMessage: `Vu sur`,
  },
});
